import type { i18n as I18n } from "i18next"
import { useMemo, type ElementType } from "react"
import { Trans, useTranslation } from "react-i18next"
import { I18_DEFAULT_NAME_SPACE } from "./constants"
import { TranslateMethods, getTranslateMethods } from "./utils"

export type UseTranslateReturn = TranslateMethods & {
  i18n: I18n
  Trans: ElementType
  ready: boolean
}

// We can handle updating the translate namespace later
export const useTranslate = (): UseTranslateReturn => {
  const { t, i18n, ready } = useTranslation(I18_DEFAULT_NAME_SPACE, {
    useSuspense: false
  })
  const translateMethods: TranslateMethods = useMemo(
    () => getTranslateMethods(t, i18n),
    [t, i18n]
  )

  return {
    ...translateMethods,
    i18n,
    Trans: Trans as ElementType,
    ready
  }
}

export default useTranslate
